import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'
export default function CertificateReady(props: any) {
    const { timeline, common } = useLocalTranslation();
    return (
        <div className='commonMainCon'>
            <p className='commonp1 mb-[8px] text-[#FD3581] font-bold'>{timeline.certificateSection.certificateReady.h1}</p>
            <p className='text-red-500 font-medium'>{props.certificateErr}</p>
            <p className='commonp1 mb-[15px]'>{timeline.certificateSection.certificateReady.p1}</p>
            <button 
                disabled={props.isCertificateBtnLoading}
                style={{
                    cursor : props.isCertificateBtnLoading ? 'not-allowed' : 'pointer',
                    backgroundColor : props.isCertificateBtnLoading ? '#b9b9ba' : '#0073E6'
                }}
                onClick={()=>props.handleCertificateClaim()}
                className='commonb1 commonb1_bg_blue cursor-pointer'>
                {common.statusText.claimCertificate}
            </button>
        </div>
    );
};


